<template>
  <div id="pretestResults">
    <div id="resultsContainerLeft">
      <div>
        <div id="resultsText">
          <!-- <p>Launch Grade</p> -->
          <div class="launch-grade">{{ getGrade() }}</div>
        </div>

        <v-row class="justify-center">
          <v-col cols="10" sm="6" lg="4">
            <div id="scoreContainer">
              <v-progress-circular
                class="score-progress"
                :rotate="-90"
                :size="150"
                :width="15"
                :value="totalScore"
                :color="getColorFromScore(totalScore)"
              >
                <span class="user-score">{{ totalScore }} / 100</span>
              </v-progress-circular>
            </div>
          </v-col>
        </v-row>
        <v-row class="justify-center" style="margin-top: 10px;">
          <v-col cols="10" sm="6" lg="4">
            <v-btn color="success" block large @click="displayMobileMentor">CONTINUE</v-btn>
          </v-col>
        </v-row>
        <div class="scrolldown-container">
          <p>Scroll down to your results</p>
          <div class="scrolldown-btn" @click="scrollToResults">
            <svg version="1.1"  x="0px" y="0px" width="50px" height="80px" viewbox="0 0 50 80" enable-background="new 0 0 50 80" xml:space="preserve">
              <path class="first-path" fill="#ffffff" d="M24.752,79.182c-0.397,0-0.752-0.154-1.06-0.463L2.207,57.234c-0.306-0.305-0.458-0.656-0.458-1.057 s0.152-0.752,0.458-1.059l2.305-2.305c0.309-0.309,0.663-0.461,1.06-0.461c0.398,0,0.752,0.152,1.061,0.461l18.119,18.119 l18.122-18.119c0.306-0.309,0.657-0.461,1.057-0.461c0.402,0,0.753,0.152,1.059,0.461l2.306,2.305 c0.308,0.307,0.461,0.658,0.461,1.059s-0.153,0.752-0.461,1.057L25.813,78.719C25.504,79.027,25.15,79.182,24.752,79.182z"></path>
              <path class="second-path" fill="#ffffff" d="M24.752,58.25c-0.397,0-0.752-0.154-1.06-0.463L2.207,36.303c-0.306-0.304-0.458-0.655-0.458-1.057 c0-0.4,0.152-0.752,0.458-1.058l2.305-2.305c0.309-0.308,0.663-0.461,1.06-0.461c0.398,0,0.752,0.153,1.061,0.461l18.119,18.12 l18.122-18.12c0.306-0.308,0.657-0.461,1.057-0.461c0.402,0,0.753,0.153,1.059,0.461l2.306,2.305 c0.308,0.306,0.461,0.657,0.461,1.058c0,0.401-0.153,0.753-0.461,1.057L25.813,57.787C25.504,58.096,25.15,58.25,24.752,58.25z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div id="resultsContainerRight">
      <div id="printIcon"><v-icon large color="grey" @click="generatePDF">mdi-printer</v-icon></div>
      <!-- <div id="printIcon"><v-icon large color="grey" @click="printReport">mdi-printer</v-icon></div> -->
      <div id="analysisHeader">
        <div id="analysisHeaderText">ANALYSIS</div>
        <div id="analysisHeaderFollowup">Here is a brief analysis of your launch readiness.<br/>Select CONTINUE to learn more.</div>
        <!-- <div id="analysisIcon"><v-icon large color="amber">mdi-lightbulb</v-icon></div> -->
      </div>
      <div id="analysisContainer">
        <div id="analysisStrengths" v-show="strengths.length > 0">
          <div id="strengthsHeader"><v-icon large color="success">mdi-check-circle</v-icon> Strengths</div>
          <div class="strength" v-for="(strength, index) in strengths" :key="`strength-${index}`">
            <div class="strength-title" v-html="strength.title"></div>
            <div class="strength-description" v-html="strength.description"></div>
          </div>
        </div>
        <div id="analysisWeaknesses" v-show="weaknesses.length > 0">
          <div id="weaknessesHeader"><v-icon large color="orange">mdi-alert</v-icon> Recommended Next Steps</div>
          <div class="weakness" v-for="(weakness, index) in weaknesses" :key="`weakness-${index}`">
            <div class="weakness-title" v-html="weakness.title"></div>
            <div class="weakness-description" v-html="weakness.description"></div>
          </div>
        </div>
      </div>
      <div id="mobileAnalysisContinueContainer">
        <v-row class="justify-center" style="margin-top: 10px;">
          <v-col cols="10" sm="6" lg="4">
            <v-btn color="success" block large @click="displayMobileMentor">CONTINUE</v-btn>
          </v-col>
        </v-row>
      </div>
    </div> 
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as jsPDF from './../../public/vendor/jspdf.min.js'

export default {
  name: 'PretestResults',
  props: {
    
  },
  computed: {
    ...mapGetters([
      'pretestAnswers',
      'sectionsToReview'
    ]),
  },
  methods: {
    ...mapActions([
      'hideResults',
      'displayReport',
      'displayMobileMentor',
      'addSectionToReview',
    ]),
    generatePDF(){
      var doc = new jsPDF();
      var source = document.getElementById('resultsContainerRight');

      var elementHandler = {
        '#ignorePDF': () => {
          return true;
        }
      };
      doc.fromHTML(source, 15, 15, {
        'width': 180,
        'elementHandlers': elementHandler
      });

      doc.save('LaunchGraderAnalysis.pdf')
    },
    printReport(){
      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      mywindow.document.write('<html><head><title>Launch Grader Analysis</title>');
      mywindow.document.write('</head><body>');
      // mywindow.document.write('<h1>Launch Grader Analysis</h1>');
      mywindow.document.write(document.getElementById('resultsContainerRight').innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      return true;
    },
    getGrade(){
      const thePretestResults = this;

      let grade = '';
      let pretestScore = 0;
      thePretestResults.pretestAnswers.forEach(answer => {
        if(answer.score !== null){
          pretestScore += answer.score;
        }
      });

      if(pretestScore <= 25){
        grade = 'Pre-flight Check...';
      }else if(pretestScore <= 50){
        grade = 'Final Systems Go!';
      }else if(pretestScore <= 75){
        grade = 'T-minus Countdown...';
      }else{
        grade = 'Lift-Off!';
      }

      return grade;
    },
    getColorFromScore(currentScore){
      let color = '';
      if(currentScore <= 25){
        color = 'red';
      }else if(currentScore <= 50){
        color = 'orange';
      }else if(currentScore <= 75){
        color = 'amber';
      }else{
        color = 'success';
      }
      return color;
    },
    showPretestQuestion(index){
      if(this.showPQuestion === index){
        this.showPQuestion = null;
      }else{
        this.showPQuestion = index;
      }
    },
    scrollToResults(){
      document.getElementById('resultsContainerRight').scrollIntoView({behavior: "smooth"})
    },
    viewReport(){
      this.hideResults();
      this.displayReport();
    },
    // TODO: EDIT THIS (AND analysisItems) TO INCLUDE THE SECTION TO FLAG FOR REVIEW IN THE ACTUAL MM PORTION?
      // PROBABLY NEED TO ADD NEW VAR IN STATE TO HAVE THE MM ToC PULL FROM/ITERATE OVER
        // sectionsToReview = [{module: '', sections: []},...]
    generateAnalysis(){
      const thePretestResults = this;
      let matchingAnalyses = [];
      let strengthOrWeakness = null;
      let adjustedLength = 0;
      thePretestResults.pretestAnswers.forEach(pretestAnswer => {
        matchingAnalyses = thePretestResults.analysisItems.filter(analysisItem => analysisItem.triggerQuestionID === pretestAnswer.questionID);
        strengthOrWeakness = null;
        adjustedLength = 0;
        if(matchingAnalyses.length > 0){
          if(Array.isArray(pretestAnswer.answer)){
            if(pretestAnswer.answer.includes('None of the above')){
              adjustedLength = -1;
            }
            strengthOrWeakness = matchingAnalyses.find(matchingAnalysis => matchingAnalysis.triggerAnswerValues.includes((pretestAnswer.answer.length + adjustedLength)));
          }else{
            strengthOrWeakness = matchingAnalyses.find(matchingAnalysis => matchingAnalysis.triggerAnswerValues.includes(pretestAnswer.answer));
          }
        }
        // sort into proper category if we found something to provide feedback on
        if(strengthOrWeakness){
          if(strengthOrWeakness.analysisType === 'strength'){
            thePretestResults.strengths.push(strengthOrWeakness);
          }else if(strengthOrWeakness.analysisType === 'weakness'){
            thePretestResults.weaknesses.push(strengthOrWeakness);
          }
        }
      });
    }
  },
  mounted(){
    const thePretestResults = this;

    thePretestResults.generateAnalysis();

    let pretestScore = 0;
    thePretestResults.pretestAnswers.forEach(answer => {
      if(answer.score !== null){
        pretestScore += answer.score;
      }
    });

    if(pretestScore > 0){
      thePretestResults.scoreInterval = setInterval(() => {
        thePretestResults.totalScore += 1;
        if(thePretestResults.totalScore === pretestScore){
          clearInterval(thePretestResults.scoreInterval);
        }
      }, 50)
    }
  },
  data(){
    return {
      showPQuestion: null,
      totalScore: 0,
      scoreInterval: {},
      strengths: [],
      weaknesses: [],
      analysisItems: [
        {
          title: 'Planning Ahead',
          description: "Best practices say you should plan your launch at least 6 months in advance, ideally 12 and you are checking your preparation at a great time.",
          triggerQuestionID: 6,
          triggerAnswerValues: ['>24 Months','12-24 Months','12 Months','6-12 Months'],
          analysisType: 'strength'
        },
        {
          title: 'Planning Ahead',
          description: "Best practices say you should plan your launch at least 6 months in advance, ideally 12.",
          triggerQuestionID: 6,
          triggerAnswerValues: ['3-6 Months','1-3 Months','1 Month'],
          analysisType: 'weakness'
        },
        {
          title: 'Saving the Date',
          description: "Great job identifying all of the major dates and milestones typically associated with a successful launch. By doing so, you have a clear path forward which will make managing the timeline and trainings leading up to launch less hectic than it would be otherwise.",
          triggerQuestionID: 7,
          triggerAnswerValues: [4],
          analysisType: 'strength'
        },
        {
          title: 'Saving the Date',
          description: "Identify major dates and milestones associated with your launch to provide a clear path forward.",
          triggerQuestionID: 7,
          triggerAnswerValues: [0,1,2,3],
          analysisType: 'weakness'
        },
        {
          title: 'Confident in Knowledge',
          description: "The knowledge and understanding of various aspects related to your launch, such as the disease state and drug's profile, should inform your training plan including depth of materials, use of gamification, types of deliverables, and more.",
          triggerQuestionID: 8,
          triggerAnswerValues: [4,5],
          analysisType: 'strength'
        },
        {
          title: 'Initial Steps',
          description: "Obtain an understanding of various aspects related to your launch, such as the disease state and drug's profile, as these play an important role in creating your training plan including depth of materials, use of gamification, types of deliverables, and more.",
          triggerQuestionID: 8,
          triggerAnswerValues: [0,1,2,3],
          analysisType: 'weakness'
        },
        {
          title: 'Digging Deeper',
          description: "Research the market, patients, and competition to improve your chances of a successful launch. The deeper your knowledge is, the more robust your training can be, resulting in knowledgeable and confident representatives entering the field.",
          triggerQuestionID: 9,
          triggerAnswerValues: [0,1,2,3,4,5],
          analysisType: 'weakness'
        },
        {
          title: 'Engaging with Stakeholders',
          description: "Great job engaging with your stakeholders. Early engagement helps align your training with the brand's overall strategy and expectations.",
          triggerQuestionID: 10,
          triggerAnswerValues: [4,5],
          analysisType: 'strength'
        },
        {
          title: 'Engaging with Stakeholders',
          description: "Engage with your key stakeholders as soon as possible to ensure that your training is aligned with the brand’s overall strategy and expectations.",
          triggerQuestionID: 10,
          triggerAnswerValues: [0,1,2,3],
          analysisType: 'weakness'
        },
        {
          title: 'Understanding the MLR Process',
          description: "Now that you understand the MLR process and submission requirements, keep in mind that it is a good idea to perform concept reviews prior to submission for any of your training materials that contain an approach MLR hasn't seen before or for complex materials.",
          triggerQuestionID: 11,
          triggerAnswerValues: ['Yes'],
          analysisType: 'strength'
        },
        {
          title: 'Understanding the MLR Process',
          description: "Begin to build a good relationship with your MLR team. They can guide you through the compliance landscape and help prevent rejections of training materials or multiple rounds of reviews. It is a good idea to perform concept reviews prior to submission for any of your training materials that contain an approach MLR hasn't seen before or for complex materials.",
          triggerQuestionID: 11,
          triggerAnswerValues: ['No'],
          analysisType: 'weakness'
        },
        {
          title: 'Consider Working with a Vendor or Training Partner',
          description: "Vendors or training partners may have materials, source files, or other expertise relating to your product that you can leverage for various aspects of the launch process.",
          triggerQuestionID: 12,
          triggerAnswerValues: ['No','Not Sure'],
          analysisType: 'weakness'
        },
        {
          title: 'Check In with Procurement',
          description: "Check to see what has been done in the past. Being able to leverage existing materials and/or the expertise of previous training partners can significantly reduce the amount of running around you'll need to do at different phases of the launch process.",
          triggerQuestionID: 15,
          triggerAnswerValues: ['No'],
          analysisType: 'weakness'
        },
        {
          title: 'Trained and Capable',
          description: "It never hurts to stay aware of what training vendors offer relating to the latest trends, technology, and launch experiences, and you're two steps ahead of those that have yet to do so.",
          triggerQuestionID: 16,
          triggerAnswerValues: ['Yes'],
          analysisType: 'strength'
        },
        {
          title: 'Get the Latest',
          description: "If you have time, look at new training vendors or catch up with existing ones to refresh on the latest trends, technology, and launch experiences.",
          triggerQuestionID: 16,
          triggerAnswerValues: ['No'],
          analysisType: 'weakness'
        },
        {
          title: 'Financially Literate',
          description: "Great job understanding the financial scope of your training. It is a good idea to include a contingency fund as part of your budget plan to cover unexpected expenses or a delay in the approval of the drug.",
          triggerQuestionID: 17,
          triggerAnswerValues: ['Yes'],
          analysisType: 'strength'
        },
        {
          title: 'Budget Awareness',
          description: "Understand the financial scope of your training to help you manage resources effectively. Once you have an idea of what that scope entails, it is also good to include a contingency fund as part of your budget plan to cover unexpected expenses or a delay in the approval of the drug.",
          triggerQuestionID: 17,
          triggerAnswerValues: ['No'],
          analysisType: 'weakness'
        },
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#pretestResults{
  top: 50px;
  position: absolute;
  left: 0;
  right: 0;
  height: calc(100% - 50px);
}

#resultsContainerLeft{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  padding-right: 0;
  width: 40%;
}

#resultsContainerRight{
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  background-image: url(../assets/img/Quiz_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  border-left: 15px solid rgba(0,0,0,0.2);
  width: 60%;
/*  padding-top: 50px;*/
/*  padding-left: 50px;*/
  padding: 15px;
  box-sizing: border-box;
  overflow: auto;
}

#resultsImage{
  text-align: center;
  min-height: 210px;
  height: calc(100vh - 650px);
  background-color: white;
  background-image: url(../assets/img/mentor_results.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

#resultsText{
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
  position: relative;
  margin: 0 auto;
  padding: 2% 0px;
  width: 90%;
}

#minimumScoreBlurb{
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
  position: relative;
  margin: 20px auto 0px auto;
  padding: 2% 0px;
  width: 90%;
}

#resultsContinue{
  position: relative;
  display: block;
  margin: 0 auto;
  margin-top: 5%;
  color: #055272;
  cursor: pointer;
}

.canvasContainer{
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.scrolldown-container {
  display: none;
  float: left;
  margin-top: 20px;
  text-align: center;
  color: #ffffff;
  width: 100%;
  height: 130px;
  position: relative;
  cursor: pointer;
}
.scrolldown-container .scrolldown-btn {
  width: 50px;
  position: absolute;
  left: 50%;
  top: 100%;
  bottom: 15%; 
  right: auto;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
}
.scrolldown-container .scrolldown-btn svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 75px;
}
.scrolldown-container .scrolldown-btn svg path.first-path {
  animation: scrollanim 2s ease-in-out infinite;
  animation-delay: 1.6s;
}
.scrolldown-container .scrolldown-btn svg path.second-path {
  animation: scrollanim2 2s ease-in-out infinite;
}

@-webkit-keyframes scrollanim {
  0% {
    -webkit-transform: translate(0, -40px);
    opacity: 0;
  }
  60% {
    -webkit-transform: translate(0, 0);
    opacity: 0.8;
  }
}
@-moz-keyframes scrollanim {
  0% {
    -moz-transform: translate(0, -40px);
    opacity: 0;
  }
  60% {
    -moz-transform: translate(0, 0);
    opacity: 0.8;
  }
}
@keyframes scrollanim {
  0% {
    -webkit-transform: translate(0, -40px);
    -moz-transform: translate(0, -40px);
    -ms-transform: translate(0, -40px);
    -o-transform: translate(0, -40px);
    transform: translate(0, -40px);
    opacity: 0;
  }
  60% {
    -webkit-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
    opacity: 0.8;
  }
}

@-webkit-keyframes scrollanim2 {
  0% {
    -webkit-transform: translate(0, -40px);
    opacity: 0;
  }
  60% {
    -webkit-transform: translate(0, 0px);
    opacity: 0.6;
  }
}
@-moz-keyframes scrollanim2 {
  0% {
    -moz-transform: translate(0, -40px);
    opacity: 0;
  }
  60% {
    -moz-transform: translate(0, 0px);
    opacity: 0.6;
  }
}
@keyframes scrollanim2 {
  0% {
    -webkit-transform: translate(0, -40px);
    -moz-transform: translate(0, -40px);
    -ms-transform: translate(0, -40px);
    -o-transform: translate(0, -40px);
    transform: translate(0, -40px);
    opacity: 0;
  }
  60% {
    -webkit-transform: translate(0, 0px);
    -moz-transform: translate(0, 0px);
    -ms-transform: translate(0, 0px);
    -o-transform: translate(0, 0px);
    transform: translate(0, 0px);
    opacity: 0.6;
  }
}

.slider{
  position: relative;
  float: left;
  padding-top: 5px;
  width: 80%
}
.pretestResultSlider{
  width: 100%;
  height: 20px;
  background-color: #b8b8b8;
  border-radius: 10px;
  margin-left: 20px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
}

.pretestQuestion, .pretestQuestionFeedback{
  color: #094058;
  position: relative;
  margin-left: 60px;
  float: left;
  clear: left;
}

.pretestQuestionFeedback{
  margin-top: 20px;
}

.correct{
  height: 20px;
  width: 50%;
  background-color: green;
  border-radius: 10px;
  margin-left: 75px;
}

.correctSlide{
  margin-left: 0px;
  -webkit-transition: margin-left 1s; 
  -moz-transition: margin-left 1s; 
  -o-transition: margin-left 1s; 
  transition: margin-left 1s; 
}

.incorrect{
  height: 20px;
  width: 50%;
  background-color: red;
  border-radius: 10px;
  position: relative;
  margin-left: 75px;
}

.incorrectSlide{
  margin-left: 50%;
  -webkit-transition: margin-left 1s; 
  -moz-transition: margin-left 1s; 
  -o-transition: margin-left 1s; 
  transition: margin-left 1s; 
}

.qNumberContainer{
  height: 40px;
  width: 40px;
  text-align: center;
  cursor: pointer;
  float: left;
}

.qNumberText{
  height: 25px;
  position: relative;
  z-index: 1;
  padding-top: 4px;
  color: #ffffff;
  font-family: MontserratBlack;
}

.qNumberImage{
  height: 33px;
  width: 50px;
  position: relative;
  margin-top: -33px;
  align-self: center;
  background-image: url("../assets/img/Results_toggle.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  text-align: center;
  transform: rotate(0deg);
  -webkit-transition: transform .2s;
  -moz-transition: transform .2s;
  -o-transition: transform .2s;
  transition: transform .2s;
}

.qNumberSelected{
  padding-top: 0;
  padding-left: 10px;
}

.rotate{
  margin-top: -26px;
  transform: rotate(90deg);
  -webkit-transition: transform .5s;
  -moz-transition: transform .5s;
  -o-transition: transform .5s;
  transition: transform .5s;
}

.resultContainer{
  width: calc(100% - 40px);
  float: left;
  clear: right;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 5px;
}

@media(max-width: 900px){
  #pretestResults{
    width: 100%;
  }
  #questionsContent{
    width: 100%;
    height: calc(100vh - 106px);
    overflow-x: hidden;
  }
  .resultContainer{
    padding-left: 0;
  }
  #resultsContainerLeft{
    /*position: fixed;*/
  }
  #resultsContainerRight{
    width: 60%;
    padding-left: 35px;
  }
}

@media(max-width: 667px){
  .scrolldown-container {
    display: block;
  }
  #resultsContainerLeft{
    height: calc(100vh - 50px);
    width: 100vw;
    top: 0;
    float: left;
    position: relative;
    
  }
  .answerChoicesInner > label{
    font-size: 1em;
    height: 65px;
  }
  #resultsContainerRight{
    height: auto;
    width: 100vw;
    float: left;
    position: relative;
    box-sizing: border-box;
    padding-top: 20px;
    padding-left: 10px;
    border-left: none;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 100px;
  }
  #resultsImage{
    display: none;
  }
  .resultContainer{
    width: 100%;
    padding-right: 0;
  }
  #resultsText{
    float: left;
    width: 100%;
    font-size: 17px;
  }
}

.launch-grade{
  font-size: 40px;
  font-weight: bold;
  font-style: italic;
}

#scoreContainer{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.score-progress >>> .v-progress-circular__overlay{
  transition: all .125s ease-in-out;
}

#analysisHeader{
  font-size: 45px;
  font-weight: bold;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1em;
}

#analysisHeaderFollowup{
  font-size: 20px;
  line-height: 1em;
  margin-top: 5px;
  text-align: center;
}

#analysisContainer{
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
}

#mobileAnalysisContinueContainer{
  display: none;
}

@media(max-width: 667px){
  #mobileAnalysisContinueContainer{
    display: block;
  }
}

#strengthsHeader, #weaknessesHeader{
  font-size: 22px;
  font-weight: bold;
  margin-top: 25px;
  margin-bottom: 5px;
}

.strength, .weakness{
  padding: 5px;
}

.strength-title, .weakness-title{
  font-weight: bold;
  margin-top: 5px;
}

#printIcon{
  position: absolute;
  z-index: 100;
  top: 15px;
  right: 15px;
}
</style>
